import { handleActions } from 'redux-actions'

import {
  SET_TAGS,
} from './tags.actions'
import { LOGOUT } from '../../actions'

const initialState = {
  data: [],
}

export default handleActions({
  [SET_TAGS]: (state, action) => ({
    ...state,
    data: action.payload,
  }),
  [LOGOUT]: () => initialState,
}, initialState)
